const NewHeroSection = () => {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{
        height: 'calc(100vh - 68px)', // Full viewport height minus header height (36px logo + 32px padding)
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        style={{ zIndex: 1 }}
      >
        <source src="/Landing Page/Hero/V1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      
      {/* Hero Content */}
      <div className="relative z-10 text-center max-w-6xl mx-auto" style={{ padding: 'clamp(16px, 5vw, 24px)' }}>
        <h1
          style={{
            fontFamily: '"FONTSPRING DEMO - The Seasons", serif',
            fontSize: 'clamp(32px, 8vw, 80px)',
            color: '#FFFFFF',
            fontWeight: '400',
            lineHeight: '1.1',
            textAlign: 'center',
            letterSpacing: '0.02em',
            wordBreak: 'break-word',
            hyphens: 'auto'
          }}
        >
          Expertly Curated,<br />
          Uniquely Yours.
        </h1>
      </div>
    </section>
  )
}

export default NewHeroSection